import { render } from "./indexIntegrationCredentialsComponent.vue?vue&type=template&id=3ef88ccb&scoped=true"
import script from "./indexIntegrationCredentialsComponent.vue?vue&type=script&lang=js"
export * from "./indexIntegrationCredentialsComponent.vue?vue&type=script&lang=js"

import "./indexIntegrationCredentialsComponent.vue?vue&type=style&index=0&id=3ef88ccb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef88ccb"]])

export default __exports__